<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7063 8.72638L9.99992 17.4333L5.29327 12.7263L6.70715 11.3125L9.99992 14.6051L17.2923 7.3125L18.7063 8.72638Z"
    />
  </svg>
</template>
